export const productFormFields = {
    productDataForm: [

        {
            order: 0,
            rowClass: "row",
            name: "row-0",
            fields: [
                {
                    order: 0,
                    name: "name", // name is also a key in JSON
                    value: null,
                    type: "text", // available types: text, number, date, checkbox, select, list and button
                    label: "Nazwa towaru",
                    required: true,
                    options: [], // for select type
                    minLength: 3, // used only to validate text fields
                    maxLength: 255, // used only to validate text fields
                    pattern: "",
                    placeholder: "Uzupełnij nazwę towaru",
                    helpText: "Pole musi zawierać od 3 do 255 znaków",
                    colClass: "col",
                },
            ],
        },
        {
            order: 2,
            rowClass: "row",
            name: "row-2",
            fields: [
                {
                    order: 0,
                    name: "bloz", // name is also a key in JSON
                    value: null,
                    type: "text", // available types: text, number, date, checkbox, select, list and button
                    label: "Bloz",
                    required: false,
                    options: [], // for select type
                    minLength: 1, // used only to validate text fields
                    maxLength: 7, // used only to validate text fields
                    pattern: "",
                    placeholder: "Wpisz BLOZ",
                    helpText: "Pole musi zawierać od 1 do 7 znaków",
                    colClass: "col-4",
                },
                {
                    order: 0,
                    name: "ean", // name is also a key in JSON
                    value: null,
                    type: "text", // available types: text, number, date, checkbox, select, list and button
                    label: "Ean",
                    required: false,
                    options: [], // for select type
                    minLength: 1, // used only to validate text fields
                    maxLength: 13, // used only to validate text fields
                    pattern: "",
                    placeholder: "Wpisz EAN",
                    helpText: "Pole musi zawierać od 1 do 13 znaków",
                    colClass: "col-4",
                },
                {
                    order: 0,
                    name: "barcode", // name is also a key in JSON
                    value: null,
                    type: "text", // available types: text, number, date, checkbox, select, list and button
                    label: "Kod kreskowy",
                    required: false,
                    options: [], // for select type
                    minLength: 1, // used only to validate text fields
                    maxLength: 128, // used only to validate text fields
                    pattern: "",
                    placeholder: "Wpisz kod kr.",
                    helpText: "Pole musi zawierać od 1 do 128 znaków",
                    colClass: "col-4",
                },
            ],
        },


        {
            order: 3,
            rowClass: "row",
            name: "row-3",
            fields: [
                {
                    order: 0,
                    name: "pkwiu", // name is also a key in JSON
                    value: null,
                    type: "text", // available types: text, number, date, checkbox, select, list and button
                    label: "PKWiU",
                    required: false,
                    options: [], // for select type
                    minLength: 1, // used only to validate text fields
                    maxLength: 255, // used only to validate text fields
                    pattern: "",
                    placeholder: "Wpisz PKWiU",
                    helpText: "Pole musi zawierać od 1 do 255 znaków",
                    colClass: "col-3",
                },
                {
                    order: 0,
                    name: "productType", // name is also a key in JSON
                    value: null,
                    type: "select", // available types: text, number, date, checkbox, select, list and button
                    label: "Typ produktu",
                    required: true,
                    options: ["OTC","RX100","RX_REF","OTC_REF","INNY"], // for select type
                    minLength: 1, // used only to validate text fields
                    maxLength: 100, // used only to validate text fields
                    pattern: "",
                    placeholder: "Wybierz typ towaru",
                    helpText: "Wybierz wartość z listy",
                    colClass: "col-3",
                },
                {
                    order: 0,
                    name: "manufacturer", // name is also a key in JSON
                    value: "Jakiś manuf",
                    type: "text", // available types: text, number, date, checkbox, select, list and button
                    label: "Producent",
                    required: false,
                    options: [], // for select type
                    minLength: 1, // used only to validate text fields
                    maxLength: 255, // used only to validate text fields
                    pattern: "",
                    placeholder: "Wpisz producenta",
                    helpText: "Pole musi zawierać od 1 do 255 znaków",
                    colClass: "col-6",
                },
            ],
        },


        {
            order: 4,
            rowClass: "row",
            name: "row-4",
            fields: [
                {
                    order: 0,
                    name: "refundedPrice", // name is also a key in JSON
                    value: 0,
                    type: "number", // available types: text, number, date, checkbox, select, list and button
                    label: "Cena urzędowa",
                    required: false,
                    options: [], // for select type
                    minLength: 0, // used only to validate text fields
                    maxLength: 255, // used only to validate text fields
                    pattern: "",
                    placeholder: "Wpisz cenę urzędową",
                    helpText: "Wartość ceny urzędowej jeśli obowiazuje dla danego towaru",
                    colClass: "col-6",
                },
                {
                    order: 1,
                    name: "sellingTax", // name is also a key in JSON
                    value: 0.0,
                    type: "number", // available types: text, number, date, checkbox, select, list and button
                    label: "Podatek VAT",
                    required: true,
                    options: [], // for select type
                    minLength: 1, // used only to validate text fields
                    maxLength: 100, // used only to validate text fields
                    pattern: "",
                    placeholder: "Wpisz stawkę VAT",
                    helpText: "Wpisz wartość stawki VAT",
                    colClass: "col-6",
                },
            ],
        },

        {
            order: 5,
            rowClass: "row",
            name: "row-5",
            fields: [
                {
                    order: 0,
                    name: "packageUnitQuantity", // name is also a key in JSON
                    value: 1,
                    type: "number", // available types: text, number, date, checkbox, select, list and button
                    label: "Ilość w opak.",
                    required: false,
                    options: [], // for select type
                    minLength: 1, // used only to validate text fields
                    maxLength: 255, // used only to validate text fields
                    pattern: "",
                    placeholder: "Wpisz ilość jednostek w op.",
                    helpText: "Pole musi zawierać od 1 do 255 znaków",
                    colClass: "col-6",
                },

                {
                    order: 2,
                    name: "packageUnit", // name is also a key in JSON
                    value: null,
                    type: "text", // available types: text, number, date, checkbox, select, list and button
                    label: "Jednostki miary",
                    required: false,
                    options: [], // for select type
                    minLength: 1, // used only to validate text fields
                    maxLength: 255, // used only to validate text fields
                    pattern: "",
                    placeholder: "Wpisz jednostkę",
                    helpText: "Pole musi zawierać od 1 do 255 znaków",
                    colClass: "col-6",
                },
            ],
        },


        {
            order: 6,
            rowClass: "row",

            name: "row-6",
            fields: [
                {
                    order: 0,
                    name: "norm-and-min-stock-section", // name is also a key in JSON
                    value:
                        "Ustawienia centralnej normy i stanu minimalnego. Służą ustaleniom norm i stanów minimalnych z punktu widzenia centralnego zapotrzebowania.",
                    type: "section", // available types: text, number, date, checkbox, select, list and button
                    label: "Ustawienia centralnej normy i stanu minimalnego",
                    options: [], // for select type
                    required: false,
                    pattern: "",
                    placeholder: "",
                    helpText:  "Ustawienia centralnej normy i stanu minimalnego. Służą ustaleniom norm i stanów minimalnych z punktu widzenia centralnego zapotrzebowania.",
                    colClass: "col",
                },
            ],
        },


        {
            order: 7,
            rowClass: "row",
            name: "row-7",
            fields: [
                {
                    order: 0,
                    name: "norm", // name is also a key in JSON
                    value: 0.0,
                    type: "number", // available types: text, number, date, checkbox, select, list and button
                    label: "Norma wyliczona",
                    required: false,
                    options: [], // for select type
                    minLength: 1, // used only to validate text fields
                    maxLength: 255, // used only to validate text fields
                    pattern: "",
                    placeholder: "Wartość wyliczana automatycznie",
                    helpText: "Pole musi zawierać od 1 do 255 znaków",
                    colClass: "col-6",
                    disabled: true,
                },

                {
                    order: 2,
                    name: "minimalStock", // name is also a key in JSON
                    value: 0.0,
                    type: "number", // available types: text, number, date, checkbox, select, list and button
                    label: "St. minimalny wyliczony",
                    required: false,
                    options: [], // for select type
                    minLength: 1, // used only to validate text fields
                    maxLength: 255, // used only to validate text fields
                    pattern: "",
                    placeholder: "Wartość wyliczana automatycznie",
                    helpText: "Pole musi zawierać od 1 do 255 znaków",
                    colClass: "col-6",
                    disabled: true,
                },
            ],
        },



        {
            order: 7,
            rowClass: "row",
            name: "row-7",
            fields: [
                {
                    order: 0,
                    name: "manualNorm", // name is also a key in JSON
                    value: 0.0,
                    type: "number", // available types: text, number, date, checkbox, select, list and button
                    label: "Norma ręczna",
                    required: false,
                    options: [], // for select type
                    minLength: 1, // used only to validate text fields
                    maxLength: 255, // used only to validate text fields
                    pattern: "",
                    placeholder: "Wpisz norme ręczna dla towaru",
                    helpText: "Pole musi zawierać od 1 do 255 znaków",
                    colClass: "col-6",
                },

                {
                    order: 2,
                    name: "manualMinimalStock", // name is also a key in JSON
                    value: 0.0,
                    type: "number", // available types: text, number, date, checkbox, select, list and button
                    label: "St. minimalny ręczny",
                    required: false,
                    options: [], // for select type
                    minLength: 1, // used only to validate text fields
                    maxLength: 255, // used only to validate text fields
                    pattern: "",
                    placeholder: "Wpisz st. min. ręczny dla towaru",
                    helpText: "Pole musi zawierać od 1 do 255 znaków",
                    colClass: "col-6",
                },
            ],
        },

        {
            order: 13,
            rowClass: "row",
            name: "row",
            fields: [

                {
                    order: 0,
                    name: "bindLocalProductsActions",
                    value: null,
                    type: "slot",
                    label: "Powiązania z lokalnymi dostawcami",
                    required: false,
                    options: [],
                    helpText: "Powiązania z lokalnymi dostawcami",
                    colClass: "col",
                },
            ],
        },
    ],
};
